module.exports = __webpack_public_path__ + "img/a25.d2d6c5e9.svg";